var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-draggable-resize-combo",
    {
      staticClass: "container",
      attrs: {
        x: _vm.logo.X,
        y: _vm.logo.Y,
        width: _vm.logo.Width,
        height: _vm.logo.Height,
      },
      on: {
        "update:x": function ($event) {
          return _vm.$set(_vm.logo, "X", $event)
        },
        "update:y": function ($event) {
          return _vm.$set(_vm.logo, "Y", $event)
        },
        "update:width": function ($event) {
          return _vm.$set(_vm.logo, "Width", $event)
        },
        "update:height": function ($event) {
          return _vm.$set(_vm.logo, "Height", $event)
        },
      },
    },
    [
      _c("img", {
        staticClass: "logo",
        style: _vm.style,
        attrs: { src: _vm.imgUrl },
        on: {
          mousedown: function ($event) {
            $event.preventDefault()
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }